<div class="booking-container" *ngIf="!loader">
  <div class="heading_sert">
    <sm-title-bar
      pageTitle="Loyalty rewards"
      [backWithParams]="true"
      [headerCustomTemplate]="addButton"
    >
      <ng-template #addButton>
        <div class="d-flex search-field">
          <!-- <button mat-button aria-label="option menu" [matMenuTriggerFor]="menu" color="accent" >
        <mat-icon class="material-icons-round try" [inline]="true">add_circle</mat-icon>
      </button> -->
          <!-- <div class="create_btn_sd">
            <button
              mat-button
              aria-label="option menu"
              color="accent"
              (click)="addpointconversion()"
              style="width: 180px"
            >
              <mat-icon>add</mat-icon>
              Point conversion
            </button>
          </div> -->
        </div>
      </ng-template>
    </sm-title-bar>
  </div>
  <div class="chip_services_list">
    <div class="loyal_miss_pp">
      <mat-chip-list class="example-chip">
        <mat-chip
          [ngClass]="{ selectloyalty: selectedValue == 3 }"
          (click)="selectchip(3)"
          >Referral loyalty</mat-chip
        >
        <mat-chip
          [ngClass]="{ selectloyalty: selectedValue == 2 }"
          (click)="selectchip(2)"
          >Payment loyalty</mat-chip
        >
        <mat-chip
          [ngClass]="{ selectloyalty: selectedValue == 4 }"
          (click)="selectchip(4)"
          >Membership loyalty</mat-chip
        >
        <mat-chip
          [ngClass]="{ selectloyalty: selectedValue == 1 }"
          (click)="selectchip(1)"
          >Booking loyalty</mat-chip
        >
      </mat-chip-list>
    </div>
    <div class="option_lx">
      <button mat-icon-button color="accent" [matMenuTriggerFor]="walletMenu">
        <mat-icon class="material-icons-round">more_vert</mat-icon>
      </button>
      <mat-menu #walletMenu="matMenu" class="wallet-menu">
        <button mat-menu-item (click)="addpointconversion()">
          <mat-icon class="material-icons-outlined">settings</mat-icon>
          <span> Point conversion</span>
        </button>
      </mat-menu>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-8">
      <div class="lsk_cardf" *ngIf="selectedValue == 1">
        <div class="serv_heading">
          <div class="adm_set">
            <mat-slide-toggle
              (change)="onToggleChangeForBooking($event)"
              [checked]="toShowCheckForBooking === 1"
            ></mat-slide-toggle>
          </div>
          <h3>Booking loyalty reward status</h3>
          <p class="booking_parax">
            {{
              toShowCheckForBooking == 1
                ? "Booking loyalty is enabled"
                : "Booking loyalty is disabled"
            }}
          </p>
        </div>
        <div class="configuration_description">
          <p>
            Let's reward your customer for their loyalty. Booking rewards allows
            customers to earn points when they book appointments through app or
            web, which they can later redeem for rewards like discounts, free
            services, or products.
          </p>
        </div>
        <div *ngIf="toShowCheckForBooking == 1">
          <div class="mainpadding" *ngIf="shop_status != '2'">
            <div class="item_list add_padding mainlist">
              <div class="item_list_data">
                <span>Shop booking</span>
                <mat-slide-toggle
                  [(ngModel)]="isShopBookingEnabled"
                ></mat-slide-toggle>
              </div>
              <div class="loyalty_payment_box" *ngIf="isShopBookingEnabled">
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Point per booking</mat-label>
                    <input
                      matInput
                      type="number"
                      smDecimalOnly
                      [(ngModel)]="bookingShopPoints"
                      placeholder="Enter points"
                    />
                  </mat-form-field>
                </div>
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Valid for (days)</mat-label>
                    <input
                      matInput
                      type="number"
                      smNumericOnly
                      [(ngModel)]="bookingShopValidity"
                      placeholder="Enter validity days"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="mainpadding" *ngIf="home_status != '2'">
            <div class="item_list add_padding mainlist">
              <div class="item_list_data">
                <span>Home booking</span>
                <mat-slide-toggle
                  [(ngModel)]="isHomeBookingEnabled"
                ></mat-slide-toggle>
              </div>
              <div class="loyalty_payment_box" *ngIf="isHomeBookingEnabled">
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Point per booking</mat-label>
                    <input
                      matInput
                      type="number"
                      smDecimalOnly
                      [(ngModel)]="bookingHomePoints"
                      placeholder="Enter points"
                    />
                  </mat-form-field>
                </div>
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Valid for (days)</mat-label>
                    <input
                      matInput
                      type="number"
                      smNumericOnly
                      [(ngModel)]="bookingHomeValidity"
                      placeholder="Enter validity days"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="mainpadding" *ngIf="virtual_status != '2'">
            <div class="item_list add_padding mainlist">
              <div class="item_list_data">
                <span>Virtual booking</span>
                <mat-slide-toggle
                  [(ngModel)]="isVirtualBookingEnabled"
                ></mat-slide-toggle>
              </div>
              <div class="loyalty_payment_box" *ngIf="isVirtualBookingEnabled">
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Point per booking</mat-label>
                    <input
                      matInput
                      type="number"
                      smDecimalOnly
                      [(ngModel)]="bookingVirtualPoints"
                      placeholder="Enter points"
                    />
                  </mat-form-field>
                </div>
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Valid for (days)</mat-label>
                    <input
                      matInput
                      type="number"
                      smNumericOnly
                      [(ngModel)]="bookingVirtualValidity"
                      placeholder="Enter validity days"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="cabh_sect">
            <button
              (click)="saveBookingLoyaltyConfiguration()"
              [disabled]="isBookingSaveDisabled()"
              mat-flat-button
              color="accent"
              class="submit-btn"
            >
              Save
            </button>
          </div>
        </div>
      </div>
      <div class="lsk_cardf" *ngIf="selectedValue == 2">
        <div class="serv_heading">
          <div class="adm_set">
            <mat-slide-toggle
              (change)="onToggleChangeForPayment($event)"
              [checked]="toShowCheckForPayment === 1"
            ></mat-slide-toggle>
          </div>
          <h3>Payment loyalty reward status</h3>
          <p class="booking_parax">
            {{
              toShowCheckForPayment === 1
                ? "Payment loyalty is enabled"
                : "Payment loyalty is disabled"
            }}
          </p>
        </div>
        <div class="configuration_description">
          <p>
            Reward points for invoice/bill payment will allow your customers to
            earn loyalty points when they pay invoices through app or integrated
            web system. These points can later be redeemed for discounts, free
            services, or other perks.
          </p>
        </div>
        <div *ngIf="toShowCheckForPayment === 1">
          <div class="item_list add_padding">
            <div class="item_list_data">
              <span>Appointment payment</span
              ><mat-slide-toggle
                [(ngModel)]="isAppointmentPaymentEnabled"
              ></mat-slide-toggle>
            </div>
            <!-- <div
                     class="loyalty_payment_box"
                     *ngIf="isAppointmentPaymentEnabled"
                     >
                     <mat-radio-group
                       class="payment_radio_group"
                       [(ngModel)]="appointmentPaymentType"
                     >
                       <div class="radio_row">
                         <mat-radio-button value="each_payment"
                           >On each payment</mat-radio-button
                         ><mat-radio-button value="payment_amount"
                           >On payment amount</mat-radio-button
                         >
                       </div>
                     </mat-radio-group>
                     <div *ngIf="appointmentPaymentType === 'each_payment'">
                       <mat-form-field appearance="outline"
                         ><mat-label>Point per payment</mat-label
                         ><input matInput type="number" smDecimalOnly [(ngModel)]="aptFixedPoints"
                       /></mat-form-field>
                     </div>
                     
                     <div
                       class="each_pay"
                       *ngIf="appointmentPaymentType === 'payment_amount'"
                     >
                       <div class="radio_row matrow">
                         <div class="amount_input">
                           <span class="text_label">For each {{currencyInfo.currencySymbol}}</span>
                           <mat-form-field appearance="outline" class="mobile_form">
                             <input matInput type="number" smDecimalOnly [(ngModel)]="aptAmountLimit"/>
                           </mat-form-field>
                         </div>
                         <div class="amount_input paymenx">
                           <span class="text_label">payment, reward</span
                           ><mat-form-field appearance="outline" class="mobile_form"
                             ><input
                               matInput
                               type="number" smDecimalOnly
                               [(ngModel)]="aptRewardPoints"
                           /></mat-form-field>
                         </div>
                         <div class="xvp">
                           <span class="text_label">point(s).</span>
                         </div>
                       </div>
                     </div>
                     <div
                       class="loyalty_points_wrap"
                       *ngIf="isAppointmentPaymentEnabled"
                     >
                       <mat-form-field appearance="outline" class="mobile_form col-12"
                         ><mat-label>Valid for (days)</mat-label>
                         <input
                           [(ngModel)]="paymentAppointmentValidity"
                           matInput
                           type="number" smNumericOnly
                           placeholder="Enter validity days"
                         />
                       </mat-form-field>
                     </div>
                     </div> -->
            <!-- new deisgn -->
            <div class="reward-box" *ngIf="isAppointmentPaymentEnabled">
              <mat-radio-group
                class="reward-radio"
                [(ngModel)]="appointmentPaymentType"
              >
                <mat-radio-button value="each_payment"
                  >On each payment</mat-radio-button
                >
                <mat-radio-button value="payment_amount"
                  >On payment amount</mat-radio-button
                >
              </mat-radio-group>
              <div *ngIf="appointmentPaymentType === 'each_payment'">
                <mat-form-field appearance="outline">
                  <mat-label>Point per payment</mat-label>
                  <input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="aptFixedPoints"
                  />
                </mat-form-field>
              </div>
              <div
                class="reward-row"
                *ngIf="appointmentPaymentType === 'payment_amount'"
              >
                <span class="label-text"
                  >For each {{ currencyInfo.currencySymbol }}</span
                >
                <mat-form-field appearance="outline" class="reward-input">
                  <input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="aptAmountLimit"
                  />
                </mat-form-field>
                <span class="label-text">payment, reward</span>
                <mat-form-field appearance="outline" class="reward-input">
                  <input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="aptRewardPoints"
                  />
                </mat-form-field>
                <span class="label-text">point(s).</span>
              </div>
              <div
                class="loyalty_points_wrap"
                *ngIf="isAppointmentPaymentEnabled"
              >
                <mat-form-field appearance="outline" class="mobile_form col-12">
                  <mat-label>Valid for (days)</mat-label>
                  <input
                    [(ngModel)]="paymentAppointmentValidity"
                    matInput
                    type="number"
                    smNumericOnly
                    placeholder="Enter validity days"
                  />
                </mat-form-field>
              </div>
            </div>
            <!-- new design end -->
          </div>
          <div class="item_list add_padding">
            <div class="item_list_data">
              <span>Membership payment</span
              ><mat-slide-toggle
                [(ngModel)]="isMembershipPaymentEnabled"
              ></mat-slide-toggle>
            </div>
            <!-- <div class="loyalty_payment_box" *ngIf="isMembershipPaymentEnabled">
                     <mat-radio-group
                     class="payment_radio_group"
                     [(ngModel)]="membershipPaymentType"
                     >
                     <div class="radio_row">
                        <mat-radio-button value="each_payment"
                           >On each payment</mat-radio-button
                           >
                        <mat-radio-button value="payment_amount"
                           >On payment amount</mat-radio-button
                           >
                     </div>
                     </mat-radio-group>
                     <div *ngIf="membershipPaymentType === 'each_payment'">
                        <mat-form-field appearance="outline"
                           >
                           <mat-label>Point per payment</mat-label
                              >
                           <input matInput type="number" smDecimalOnly [(ngModel)]="memFixedPoints"
                           />
                        </mat-form-field>
                     </div>
                     <div
                        class="each_pay"
                        *ngIf="membershipPaymentType === 'payment_amount'"
                        >
                        <div class="radio_row matrow">
                           <div class="amount_input">
                              <span class="text_label">For each {{currencyInfo.currencySymbol}}</span
                                 >
                              <mat-form-field appearance="outline" class="mobile_form"
                                 ><input matInput type="number" smDecimalOnly [(ngModel)]="memAmountLimit"
                                 />
                              </mat-form-field>
                           </div>
                           <div class="amount_input paymenx">
                              <span class="text_label">payment, reward</span
                                 >
                              <mat-form-field appearance="outline" class="mobile_form"
                                 ><input
                                 matInput
                                 type="number" smDecimalOnly
                                 [(ngModel)]="memRewardPoints"
                                 />
                              </mat-form-field>
                           </div>
                           <div class="xvp">
                              <span class="text_label">point(s).</span>
                           </div>
                        </div>
                        <div
                           class="loyalty_points_wrap"
                           *ngIf="isMembershipPaymentEnabled"
                           >
                           <mat-form-field
                              appearance="outline"
                              class="mobile_form col-12"
                              >
                              <mat-label>Valid for (days)</mat-label>
                              <input
                              [(ngModel)]="paymentMembrshipValidity"
                              matInput
                              type="number" smNumericOnly
                              placeholder="Enter validity days"
                              />
                           </mat-form-field>
                        </div>
                     </div>
                  </div> -->

            <!-- new design start -->
            <div class="reward-box" *ngIf="isMembershipPaymentEnabled">
              <mat-radio-group
                class="reward-radio"
                [(ngModel)]="membershipPaymentType"
              >
                <mat-radio-button value="each_payment"
                  >On each payment</mat-radio-button
                >
                <mat-radio-button value="payment_amount"
                  >On payment amount</mat-radio-button
                >
              </mat-radio-group>
              <div *ngIf="membershipPaymentType === 'each_payment'">
                <mat-form-field appearance="outline">
                  <mat-label>Point per payment</mat-label>
                  <input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="memFixedPoints"
                  />
                </mat-form-field>
              </div>
              <div
                class="reward-row"
                *ngIf="membershipPaymentType === 'payment_amount'"
              >
                <span class="label-text"
                  >For each {{ currencyInfo.currencySymbol }}</span
                >
                <mat-form-field appearance="outline" class="reward-input">
                  <input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="memAmountLimit"
                  />
                </mat-form-field>
                <span class="label-text">payment, reward</span>
                <mat-form-field appearance="outline" class="reward-input">
                  <input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="memRewardPoints"
                  />
                </mat-form-field>
                <span class="label-text">point(s).</span>
              </div>
              <div
                class="loyalty_points_wrap"
                *ngIf="isMembershipPaymentEnabled"
              >
                <mat-form-field appearance="outline" class="mobile_form col-12">
                  <mat-label>Valid for (days)</mat-label>
                  <input
                    [(ngModel)]="paymentMembrshipValidity"
                    matInput
                    type="number"
                    smNumericOnly
                    placeholder="Enter validity days"
                  />
                </mat-form-field>
              </div>
            </div>
            <!-- new design end -->
          </div>
          <div class="item_list add_padding">
            <div class="item_list_data">
              <span>Other payment</span
              ><mat-slide-toggle
                [(ngModel)]="isOtherPaymentEnabled"
              ></mat-slide-toggle>
            </div>
            <!-- <div class="loyalty_payment_box" *ngIf="isOtherPaymentEnabled">
                     <mat-radio-group
                     class="payment_radio_group"
                     [(ngModel)]="otherPaymentType"
                     >
                     <div class="radio_row">
                        <mat-radio-button value="each_payment"
                           >On each payment</mat-radio-button
                           >
                        <mat-radio-button value="payment_amount"
                           >On payment amount</mat-radio-button
                           >
                     </div>
                     </mat-radio-group>
                     <div *ngIf="otherPaymentType === 'each_payment'">
                        <mat-form-field appearance="outline"
                           >
                           <mat-label>Point per payment</mat-label
                              >
                           <input matInput type="number" smDecimalOnly [(ngModel)]="othFixedPoints"
                           />
                        </mat-form-field>
                     </div>
                     <div
                        class="each_pay"
                        *ngIf="otherPaymentType === 'payment_amount'"
                        >
                        <div class="radio_row matrow">
                           <div class="amount_input">
                              <span class="text_label">For each {{currencyInfo.currencySymbol}}</span
                                 >
                              <mat-form-field appearance="outline" class="mobile_form"
                                 ><input matInput type="number" smDecimalOnly [(ngModel)]="othAmountLimit"
                                 />
                              </mat-form-field>
                           </div>
                           <div class="amount_input paymenx">
                              <span class="text_label">payment, reward</span
                                 >
                              <mat-form-field appearance="outline" class="mobile_form"
                                 ><input
                                 matInput
                                 type="number" smDecimalOnly
                                 [(ngModel)]="othRewardPoints"
                                 />
                              </mat-form-field>
                           </div>
                           <div class="xvp">
                              <span class="text_label">point(s).</span>
                           </div>
                        </div>
                     </div>
                     <div class="loyalty_points_wrap" *ngIf="isOtherPaymentEnabled">
                        <mat-form-field appearance="outline" class="mobile_form col-12"
                           >
                           <mat-label>Valid for (days)</mat-label>
                           <input
                           [(ngModel)]="paymentOtherValidity"
                           matInput
                           type="number" smNumericOnly
                           placeholder="Enter validity days"
                           />
                        </mat-form-field>
                     </div>
                  </div> -->

            <!-- new design start -->
            <div class="reward-box" *ngIf="isOtherPaymentEnabled">
              <mat-radio-group
                class="reward-radio"
                [(ngModel)]="otherPaymentType"
              >
                <mat-radio-button value="each_payment"
                  >On each payment</mat-radio-button
                >
                <mat-radio-button value="payment_amount"
                  >On payment amount</mat-radio-button
                >
              </mat-radio-group>
              <div *ngIf="otherPaymentType === 'each_payment'">
                <mat-form-field appearance="outline">
                  <mat-label>Point per payment</mat-label>
                  <input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="othFixedPoints"
                  />
                </mat-form-field>
              </div>
              <div
                class="reward-row"
                *ngIf="otherPaymentType === 'payment_amount'"
              >
                <span class="label-text"
                  >For each {{ currencyInfo.currencySymbol }}</span
                >
                <mat-form-field appearance="outline" class="reward-input">
                  <input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="othAmountLimit"
                  />
                </mat-form-field>
                <span class="label-text">payment, reward</span>
                <mat-form-field appearance="outline" class="reward-input">
                  <input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="othRewardPoints"
                  />
                </mat-form-field>
                <span class="label-text">point(s).</span>
              </div>
              <div class="loyalty_points_wrap" *ngIf="isOtherPaymentEnabled">
                <mat-form-field appearance="outline" class="mobile_form col-12">
                  <mat-label>Valid for (days)</mat-label>
                  <input
                    [(ngModel)]="paymentOtherValidity"
                    matInput
                    type="number"
                    smNumericOnly
                    placeholder="Enter validity days"
                  />
                </mat-form-field>
              </div>
            </div>
            <!-- new design end -->
          </div>
          <div class="cabh_sect">
            <button
              (click)="savePaymentLoyaltyConfiguration()"
              [disabled]="isPaymentSaveDisabled()"
              mat-flat-button
              color="accent"
              class="submit-btn"
            >
              Save
            </button>
          </div>
        </div>
      </div>
      <div class="lsk_cardf" *ngIf="selectedValue == 3">
        <div class="serv_heading">
          <div class="adm_set">
            <mat-slide-toggle
              (change)="onToggleChangeForReferral($event)"
              [checked]="toShowCheckForReferral === 1"
            ></mat-slide-toggle>
          </div>
          <h3>Referral loyalty reward status</h3>
          <p class="booking_parax">
            {{
              toShowCheckForReferral === 1
                ? "Referral loyalty is enabled"
                : "Referral loyalty is disabled"
            }}
          </p>
        </div>
        <div class="configuration_description">
          <p>
            A "Refer-a-friend" program let your customer earn reward points for
            successfully inviting new customers to the business. It's a win-win.
            Your referrer customer gets a reward for helping the business grow.
            You get a new customer.
          </p>
        </div>
        <div *ngIf="toShowCheckForReferral === 1">
          <div class="item_list add_padding">
            <div class="item_list_data">
              <span>On refer a friend</span
              ><mat-slide-toggle
                [(ngModel)]="isReferFriendEnabled"
              ></mat-slide-toggle>
            </div>
            <div class="loyalty_payment_box" *ngIf="isReferFriendEnabled">
              <div class="loyalty_points_wrap">
                <mat-form-field appearance="outline" class="mobile_form col-12">
                  <mat-label>Points per refer</mat-label>
                  <input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="referFriendPoints"
                  />
                </mat-form-field>
              </div>
              <div class="loyalty_points_wrap">
                <mat-form-field appearance="outline" class="mobile_form col-12">
                  <mat-label>Valid for (days)</mat-label>
                  <input
                    [(ngModel)]="referralValidity"
                    matInput
                    type="number"
                    smNumericOnly
                    placeholder="Enter validity days"
                  />
                </mat-form-field>
              </div>
              <div class="loyalty_payment_box">
                <div
                  class="add_crt"
                  style="display: flex; gap: 20px; margin-top: 10px"
                >
                  <div class="try">
                    <mat-checkbox [(ngModel)]="isPointToReferee"></mat-checkbox>
                    <label
                      style="margin-left: 10px; position: relative; top: -3px"
                      for="testing1"
                      class="check-label"
                      >Credit points to referred person
                    </label>
                  </div>
                </div>
                <div class="loyalty_points_wrap" *ngIf="isPointToReferee">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Points to referred person</mat-label>
                    <input
                      matInput
                      type="number"
                      smDecimalOnly
                      [(ngModel)]="referFriendReferrerPoints"
                    />
                  </mat-form-field>
                </div>
                <div class="loyalty_points_wrap" *ngIf="isPointToReferee">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Valid for (days)</mat-label>
                    <input
                      [(ngModel)]="referFriendReferredPointsValidity"
                      matInput
                      type="number"
                      smNumericOnly
                      placeholder="Enter validity days"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="item_list add_padding">
            <div class="item_list_data">
              <span>On first booking / membership by referred person</span
              ><mat-slide-toggle
                [(ngModel)]="isBookingByRefereeEnabled"
              ></mat-slide-toggle>
            </div>
            <div class="loyalty_payment_box" *ngIf="isBookingByRefereeEnabled">
              <div class="loyalty_points_wrap">
                <mat-form-field appearance="outline" class="mobile_form col-12">
                  <mat-label>Points on first booking</mat-label>
                  <input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="refereeBookingPoints"
                  />
                </mat-form-field>
              </div>
              <div class="loyalty_points_wrap">
                <mat-form-field appearance="outline" class="mobile_form col-12">
                  <mat-label>Valid for (days)</mat-label>
                  <input
                    [(ngModel)]="referralBookingValidity"
                    matInput
                    type="number"
                    smNumericOnly
                    placeholder="Enter validity days"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="item_list add_padding">
            <div class="item_list_data">
              <span>On first payment by referred person</span
              ><mat-slide-toggle
                [(ngModel)]="isPaymentByRefereeEnabled"
              ></mat-slide-toggle>
            </div>

            <!-- <div class="loyalty_payment_box" *ngIf="isPaymentByRefereeEnabled">
                     <mat-radio-group
                     class="payment_radio_group"
                     [(ngModel)]="referralPaymentType"
                     >
                     <div class="radio_row">
                        <mat-radio-button value="each_payment"
                           >Fixed point</mat-radio-button
                           >
                        <mat-radio-button value="payment_amount"
                           >On first payment amount</mat-radio-button
                           >
                     </div>
                     </mat-radio-group>
                     <div *ngIf="referralPaymentType === 'each_payment'">
                        <mat-form-field appearance="outline"
                           >
                           <mat-label>Point on first payment</mat-label
                              >
                           <input
                           matInput
                           type="number" smDecimalOnly
                           [(ngModel)]="referralPaymentFixedPoints"
                           />
                        </mat-form-field>
                     </div>
                     <div
                        class="each_pay"
                        *ngIf="referralPaymentType === 'payment_amount'"
                        >
                        <div class="radio_row matrow">
                           <div class="amount_input">
                              <span class="text_label">For each {{currencyInfo.currencySymbol}}</span
                                 >
                              <mat-form-field appearance="outline"
                                 ><input
                                 matInput
                                 type="number" smDecimalOnly
                                 [(ngModel)]="referralPaymentAmountLimit"
                                 />
                              </mat-form-field>
                           </div>
                           <div class="amount_input paymenx">
                              <span class="text_label">payment, reward</span
                                 >
                              <mat-form-field appearance="outline"
                                 ><input
                                 matInput
                                 type="number" smDecimalOnly
                                 [(ngModel)]="referralPaymentRewardPoints"
                                 />
                              </mat-form-field>
                           </div>
                           <div class="xvp">
                              <span class="text_label">point(s).</span>
                           </div>
                        </div>
                     </div>
                     <div
                        class="loyalty_points_wrap"
                        *ngIf="isPaymentByRefereeEnabled"
                        >
                        <mat-form-field appearance="outline" class="mobile_form col-12"
                           >
                           <mat-label>Valid for (days)</mat-label>
                           <input
                           [(ngModel)]="referralPaymentValidity"
                           matInput
                           type="number" smNumericOnly
                           placeholder="Enter validity days"
                           />
                        </mat-form-field>
                     </div>
                  </div> -->

            <!-- new design start -->
            <div class="reward-box" *ngIf="isPaymentByRefereeEnabled">
              <mat-radio-group
                class="reward-radio"
                [(ngModel)]="referralPaymentType"
              >
                <mat-radio-button value="each_payment"
                  >On any payment</mat-radio-button
                >
                <mat-radio-button value="payment_amount"
                  >Based on payment value</mat-radio-button
                >
              </mat-radio-group>
              <div *ngIf="referralPaymentType === 'each_payment'">
                <mat-form-field appearance="outline">
                  <mat-label>Point on first payment</mat-label>
                  <input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="referralPaymentFixedPoints"
                  />
                </mat-form-field>
              </div>
              <div
                class="reward-row"
                *ngIf="referralPaymentType === 'payment_amount'"
              >
                <span class="label-text"
                  >For each {{ currencyInfo.currencySymbol }}</span
                >
                <mat-form-field appearance="outline" class="reward-input">
                  <input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="referralPaymentAmountLimit"
                  />
                </mat-form-field>
                <span class="label-text">payment, reward</span>
                <mat-form-field appearance="outline" class="reward-input">
                  <input
                    matInput
                    type="number"
                    smDecimalOnly
                    [(ngModel)]="referralPaymentRewardPoints"
                  />
                </mat-form-field>
                <span class="label-text">point(s).</span>
              </div>
              <div
                class="loyalty_points_wrap"
                *ngIf="isPaymentByRefereeEnabled"
              >
                <mat-form-field appearance="outline" class="mobile_form col-12">
                  <mat-label>Valid for (days)</mat-label>
                  <input
                    [(ngModel)]="referralPaymentValidity"
                    matInput
                    type="number"
                    smNumericOnly
                    placeholder="Enter validity days"
                  />
                </mat-form-field>
              </div>
            </div>
            <!-- new design end -->
          </div>
          <div class="cabh_sect">
            <button
              (click)="saveReferralLoyaltyConfiguration()"
              [disabled]="isReferralSaveDisabled()"
              mat-flat-button
              color="accent"
              class="submit-btn"
            >
              Save
            </button>
          </div>
        </div>
      </div>
      <div class="lsk_cardf" *ngIf="selectedValue == 4">
        <div class="serv_heading">
          <div class="adm_set">
            <mat-slide-toggle
              (change)="onToggleChangeForMembership($event)"
              [checked]="toShowCheckForMembership === 1"
            ></mat-slide-toggle>
          </div>
          <h3>Membership loyalty reward status</h3>
          <p class="booking_parax">
            {{
              toShowCheckForMembership == 1
                ? "Membership loyalty is enabled"
                : "Membership loyalty is disabled"
            }}
          </p>
        </div>
        <div class="configuration_description">
          <p>
            Reward points help drive growth while controlling costs. With new
            memberships one can receive rewards too. This gives members a sense
            of recognition and added value for being part of the community,
            encouraging continued engagement and long-term membership.
          </p>
        </div>
        <div *ngIf="toShowCheckForMembership == 1">
          <div class="mainpadding" *ngIf="shop_status != '2'">
            <div class="item_list add_padding mainlist">
              <div class="item_list_data">
                <span>In-premise membership</span>
                <mat-slide-toggle
                  [(ngModel)]="isInPremiseMembershipEnabled"
                ></mat-slide-toggle>
              </div>
              <div
                class="loyalty_payment_box"
                *ngIf="isInPremiseMembershipEnabled"
              >
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Points on membership</mat-label>
                    <input
                      matInput
                      type="number"
                      smDecimalOnly
                      [(ngModel)]="membershipInPremisePoints"
                      placeholder="Enter points"
                    />
                  </mat-form-field>
                </div>
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Valid for (days)</mat-label>
                    <input
                      matInput
                      type="number"
                      smNumericOnly
                      [(ngModel)]="membershipInPremiseValidity"
                      placeholder="Enter validity days"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="mainpadding" *ngIf="home_status != '2'">
            <div class="item_list add_padding mainlist">
              <div class="item_list_data">
                <span>Home membership</span>
                <mat-slide-toggle
                  [(ngModel)]="isHomeMembershipEnabled"
                ></mat-slide-toggle>
              </div>
              <div class="loyalty_payment_box" *ngIf="isHomeMembershipEnabled">
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Points on membership</mat-label>
                    <input
                      matInput
                      type="number"
                      smDecimalOnly
                      [(ngModel)]="membershipHomePoints"
                      placeholder="Enter points"
                    />
                  </mat-form-field>
                </div>
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Valid for (days)</mat-label>
                    <input
                      matInput
                      type="number"
                      smNumericOnly
                      [(ngModel)]="membershipHomeValidity"
                      placeholder="Enter validity days"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="mainpadding" *ngIf="virtual_status != '2'">
            <div class="item_list add_padding mainlist">
              <div class="item_list_data">
                <span>Virtual membership</span>
                <mat-slide-toggle
                  [(ngModel)]="isVirtualMembershipEnabled"
                ></mat-slide-toggle>
              </div>
              <div
                class="loyalty_payment_box"
                *ngIf="isVirtualMembershipEnabled"
              >
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Points on membership</mat-label>
                    <input
                      matInput
                      type="number"
                      smDecimalOnly
                      [(ngModel)]="membershipVirtualPoints"
                      placeholder="Enter points"
                    />
                  </mat-form-field>
                </div>
                <div class="loyalty_points_wrap">
                  <mat-form-field
                    appearance="outline"
                    class="mobile_form col-12"
                  >
                    <mat-label>Valid for (days)</mat-label>
                    <input
                      matInput
                      type="number"
                      smNumericOnly
                      [(ngModel)]="membershipVirtualValidity"
                      placeholder="Enter validity days"
                    />
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="cabh_sect">
            <button
              (click)="saveMembershipLoyaltyConfiguration()"
              [disabled]="isMembershipSaveDisabled()"
              mat-flat-button
              color="accent"
              class="submit-btn"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-4 booking-sidebar">
      <div class="faq">
        <mat-accordion>
          <mat-expansion-panel
            [expanded]="panelState[0]"
            (opened)="panelState[0] = true"
            (closed)="panelState[0] = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title>How will customers earn points?</mat-panel-title>
            </mat-expansion-panel-header>
            <p>
              Customer can earn rewards points on a new booking, new membership,
              after paying an invoice and referring your business to a friend
              too.
            </p>
          </mat-expansion-panel>
          <mat-expansion-panel
            (opened)="panelState[1] = true"
            (closed)="panelState[1] = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title
                >What can points be redeemed for?</mat-panel-title
              >
            </mat-expansion-panel-header>
            <p>
              The earned points can be transferred to Wallet as Wallet Cash.
              Customers can use the Wallet Cash for payments of services,
              membership subscription and product purchases.
            </p>
          </mat-expansion-panel>
          <mat-expansion-panel
            (opened)="panelState[2] = true"
            (closed)="panelState[2] = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title
                >What is the points-to-wallet-cash ratio?</mat-panel-title
              >
            </mat-expansion-panel-header>
            <p>
              The conversion ratio can be set by you. By default it's 1. That
              means with transferring 1 Reward Point to Wallet, one can earn 1
              Wallet Cash.
            </p>
          </mat-expansion-panel>
          <mat-expansion-panel
            (opened)="panelState[3] = true"
            (closed)="panelState[3] = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title
                >Can customers track their points balance and redemption
                history?</mat-panel-title
              >
            </mat-expansion-panel-header>
            <p>
              Absolutely. Customers and members of your business can check all
              the data in their Reward Points section, in app and website.
            </p>
          </mat-expansion-panel>
          <mat-expansion-panel
            (opened)="panelState[4] = true"
            (closed)="panelState[4] = false"
          >
            <mat-expansion-panel-header>
              <mat-panel-title
                >What about the old bookings, payments, membership if I change
                configure data now?</mat-panel-title
              >
            </mat-expansion-panel-header>
            <p>
              The reward points received by your customers from old
              configuration will be untouched if you change the configuration
              now.
            </p>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>
